import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,Validators } from '@angular/forms'; // Add FormBuilder and FormGroup
import Swal from 'sweetalert2';

@Component({
  selector: 'app-student-group-request-list',
  templateUrl: './student-group-request-list.component.html',
  styleUrls: ['./student-group-request-list.component.scss']
})
export class StudentGroupRequestListComponent implements OnInit {

  customers: any = [];
  dtOptions: DataTables.Settings = {};
  mentorcourse: FormGroup; // Add form group
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  permanent_token:any=JSON.parse(localStorage.getItem('permanent_token'));

  zones: any = this.apiService.all_districts_zone;
  user_name: any = this.apiService.user_details.firstname;
  user_id: any = this.apiService.user_details.id;
  userDistrict: any = this.apiService.user_details.district;
  userConstituency: any = this.apiService.user_details.constituency;


  constructor(
    private apiService: ApiServiceService,
    private spinnerService: NgxSpinnerService,
    private fb: FormBuilder
  ) { }


  ngOnInit(): void {
    this.loadCourseRequests();
  }
  private loadCourseRequests(): void {
    console.log(this.user_id)
    this.spinnerService.show();  // Start spinner
    this.apiService.getStudentgroupRequestCourse(this.user_id,this.permanent_token).subscribe({
      next: (data: any[]) => {
        console.log(data)
        this.customers = data;
      },
      error: (error: any) => {
        console.error('Error fetching course requests:', error);
        this.spinnerService.hide();  // Stop spinner on error
      },
      complete: () => {
        this.spinnerService.hide();  // Stop spinner on completion
      }
    });
  }
}
